var React = require('react');

function ScaleIndex (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"79","height":"15","fill":"url(#paint0_linear_4336_83487)","stroke":"#A3A3A3","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_4336_83487","x1":"80","y1":"16","x2":"-4.47035e-07","y2":"16","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#136329","key":0}),React.createElement("stop",{"offset":"0.49274","stopColor":"#F8FAF8","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#8C3A6D","key":2})]))]);
}

ScaleIndex.defaultProps = {"width":"80","height":"16","viewBox":"0 0 80 16","fill":"none"};

module.exports = ScaleIndex;

ScaleIndex.default = ScaleIndex;
